

import { Action, Getter, namespace } from "vuex-class"
import { Component, Vue, Watch, Prop } from "vue-property-decorator"

import { TimeManagementSettings, UserFilterField } from "@/types/timeManagement"
import { Field } from "@/types"

import vSelect from "vue-select"

const setup = namespace("setup")

@Component({
	components: {
		"v-select": vSelect
	}
})
export default class UserFilterFieldSetup extends Vue {
	@setup.State
	fields!: Field[]

	@setup.State userFields!: Field[]

	@Prop()
	value!: UserFilterField[]

	columns = [
		{
			key: "recordField"
		},
		{
			key: "userField"
		},
		{
			key: "controls",
			label: ""
		}
	]

	get listTypeFields (): Field[] {
		return this.fields.filter(f => f.dataType === "list" || f.dataType === "list-multiple")
	}

	get listTypeUserFields (): Field[] {
		return this.userFields.filter(f => f.dataType === "list" || f.dataType === "list-multiple")
	}

	add () {
		this.$emit("input", [
			...this.value,
			{
				userField: null,
				recordField: null
			}
		])
	}

	remove (filter: UserFilterField) {
		this.$emit("input", this.value.filter(i => i !== filter))
	}

	availableListTypeFields (filter: UserFilterField) {
		return this.listTypeFields.filter(f => f.id === filter.recordField || !this.value.some(v => v.recordField === f.id))
	}

	setUserFieldValue (filter: UserFilterField, userFieldId: string) {
		this.$emit("input", this.value.map(item => {
			return item === filter ? { ...filter, userField: userFieldId } : item
		}))
	}

	setRecordFieldValue (filter: UserFilterField, recordFieldId: string) {
		this.$emit("input", this.value.map(item => {
			return item === filter ? { ...filter, recordField: recordFieldId } : item
		}))
	}
}
